<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';

import "@simonwep/pickr/dist/themes/classic.min.css"; // 'classic' theme 
import "@simonwep/pickr/dist/themes/monolith.min.css"; // 'monolith' theme 
import "@simonwep/pickr/dist/themes/nano.min.css";
import DataTable from 'datatables.net-vue3';
import flatPickr from "vue-flatpickr-component";
import moment from 'moment';

import Swal from "sweetalert2";

export default {
  page: {
    title: "Vouchers",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "Vouchers",
      items: [
        {
          text: "Voucher",
          href: "/",
        },
        {
          text: "List Of Vouchers",
          active: true,
        },
      ],
      date: {       enableTime: true,
                    dateFormat: "Y-m-d H:i:S",
                },

        PickUpdate:'',
        VoucherID_:'',
        ridername:'',
        typedeliver:'',


        remark:'',

        VoucherList:[],

        country:[],
        // country_:'Please select country',
        organization:[],
        orgaznization_:'',

      //loding
        VoucherSeen:true,
        RiderSeen:true,

        AssignRiderSeen:true,
        //button hide
        showFormToAssignRider:false,
        ButtonSeen:true,
        startDate:'',
        endDate:'',
        vouchername:'',
        country_:'',
        error_startDate:'',
        error_endDate:'',
        error_country:'',
        error_vouchername:'',
        error_file:'',
        dataforidedit:'',
        status:'',
        filename:'',
        cloudFrontURL: process.env.VUE_APP_BUCKET,

      //
    };
  },


     methods: {
        addnew() {
            // document.getElementById("addform").reset();
            document.getElementById('voucheraddLabel').innerHTML = "Add Voucher";
            document.getElementById('add-btn').style.display = 'block';
            document.getElementById('edit-btn').style.display = 'none';
            document.getElementById('status').style.display = 'none';
            this.vouchername = '';
            this.startDate = '';
            this.endDate = '';
            this.country_ = '';
            this.dataforidedit = '';
            this.status = '';
            this.filename= '';

        },
        editdata(data) {
            document.getElementById('voucheraddLabel').innerHTML = "Edit Voucher"
            console.log("Data",data);
            this.vouchername = data.name;
            this.startDate = data.created_at;
            this.endDate = data.end_date;
            this.country_ = data.country_id;
            this.dataforidedit = data.id;
            this.status = data.status;
            this.filename= data.file_name;
            document.getElementById('edit-btn').style.display = 'block';
            document.getElementById('add-btn').style.display = 'none'
            document.getElementById('status').style.display = 'contents';
      },
        getVoucher(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'voucher/getvoucher')
            .then(response => {
                if (response) {

                    if(response.data.status=='error'){
                        
                        this.messageBag = response.data.msj;
                        this.VoucherSeen = false;
                    }else{
                        this.VoucherList = response.data;
                        this.VoucherSeen = false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.VoucherSeen = false;
                }
               
                // console.log("Voucherlist",this.VoucherList);
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.VoucherSeen = false;
            });
        },

        // a href
        GoToDetailPage(VoucherID){
            // console.log(VoucherID);
            this.$router.push('/Voucher/details/'+VoucherID); 
        },

        //end of a href


        GetCountry(){
            // this.isLoadingListDevices=true;
            // console.log('******');
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'country')
            .then(response => {
            // console.log('xxxxxxx');
                if (response) {
                    if(response.data.status=='error'){
                        // console.log('aaaaaaaaaa');
                        this.messageBag = response.data.msj;
                        this.countreload = true;
                    }else{
                        // console.log(response.data);
                        this.country = response.data;
                        this.countreload = true;
                        
                    }
                    
                } else {
                    // console.log('daddddd');
                    this.messageBag = ['No record.'];
                    this.countreload = true;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.countreload = true;
            });
        },
        GetOrganization(){
            // this.isLoadingListDevices=true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'org/list')
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        // console.log('aaaaaaaaaa');
                        this.messageBag = response.data.msj;
                        this.countreload = true;
                    }else{

                        this.orgaznization = response.data;
                        this.countreload = true;
                        
                    }
                    
                } else {
                    // console.log('daddddd');
                    this.messageBag = ['No record.'];
                    this.countreload = true;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.countreload = true;
            });
        },
        format_date(value){
         if (value) {
            return moment(String(value)).format("DD MMM YYYY, h:mm:ss")
            }
        },

        UpdateVoucher(){
            this.LoadingUploadSeen=true; //yak
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);
            formData.append('start_date', this.startDate);
            formData.append('end_date', this.endDate);
            formData.append('country', this.country_);
            formData.append('orgaznization', this.orgaznization_);
            formData.append('name', this.vouchername);
            formData.append('status', this.status);
            formData.append('type', this.type_price);

            const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

            if(this.startDate == ''){
                    this.error_startDate = 'Please Enter Start Date';
            }else{
                this.error_startDate = '';
            }
            
            if(this.endDate == ''){
                    this.error_endDate = 'Please Enter End Date';
            }else{
                this.error_endtDate = '';
            }
            if(this.vouchername == ''){
                    this.error_vouchername = 'Please Select Voucher Name';
            }else{
                this.error_vouchername = '';
            }
            if(this.country_ == ''){
                    this.error_country = 'Please Select Country';
            }else{
                this.error_country = '';
            }
            if(this.Images == undefined){
                    this.error_file = 'Please Upload File';
            }else{
                this.error_file = '';
            }
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'voucher/edit/'+this.dataforidedit, formData, 
                { headers }
            ).then((res) => {
                    this.DevicesUpload ='';
                    // console.log(res.data);
                    // console.log(res.data.id);

                    if(res.data.status=='error'){
                        this.messageBag = res.data.msj;
                        this.isLoadingListDevices = false;
                        this.getUploadDevicesSeen = false;
                        this.uploadYes=true;
                    }else if(res.data.status=='successfully'){
                        document.getElementById('closemodal').click();
                        // this.getVoucher();
                        window.location.reload();
                    }else{
                        this.messageBag=null;
                        this.getUploadDevices(res.data.id);
                        
                    }
                    this.LoadingUploadSeen=false;
                }
            );
            
        },


        AddNewVoucher(){
            this.LoadingUploadSeen=true; //yak
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);
            formData.append('start_date', this.startDate);
            formData.append('end_date', this.endDate);
            formData.append('country', this.country_);
            formData.append('orgaznization', this.orgaznization_);
            formData.append('name', this.vouchername);
            formData.append('type', this.type_price);

            const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

            if(this.startDate == ''){
                    this.error_startDate = 'Please Enter Start Date';
            }else{
                this.error_startDate = '';
            }
            
            if(this.endDate == ''){
                    this.error_endDate = 'Please Enter End Date';
            }else{
                this.error_endtDate = '';
            }
            if(this.vouchername == ''){
                    this.error_vouchername = 'Please Select Voucher Name';
            }else{
                this.error_vouchername = '';
            }
            if(this.country_ == ''){
                    this.error_country = 'Please Select Country';
            }else{
                this.error_country = '';
            }
            if(this.Images == undefined){
                    this.error_file = 'Please Upload File';
            }else{
                this.error_file = '';
            }
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'voucher/crete', formData, 
                { headers }
            ).then((res) => {
                    this.DevicesUpload ='';
                    // console.log(res.data);
                    // console.log(res.data.id);

                    if(res.data.status=='error'){
                        this.messageBag = res.data.msj;
                        this.isLoadingListDevices = false;
                        this.getUploadDevicesSeen = false;
                        this.uploadYes=true;
                    }else if(res.data.status=='successfully'){
                        this.getVoucher();
                        
                        Swal.fire({
                            title:"Upload Voucher Success!", 
                            icon:"success",
                        }).then(() => {
                            location.reload();
                        });
                        document.getElementById('closemodal').click();
                    }else{
                        Swal.fire({
                            title:"Upload Voucher Fail!", 
                            icon:"danger",
                        })
                        this.messageBag=null;
                        this.getUploadDevices(res.data.id);
                        
                    }
                    this.LoadingUploadSeen=false;
                }
            );
            
        },

        uploadFile() {
            this.Images = this.$refs.file.files[0];
        },
     },
     
     mounted() {
        if(this.role != 3){
            this.getVoucher();
            this.GetOrganization();
            this.GetCountry();
            
        }else{
            alert('You are not authorized to view the requested page!')
        }
	},


  components: {
    Layout,
    PageHeader,
    DataTable,
    flatPickr,
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">List Of Voucher</h4>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#voucheradd" @click="addnew">Add Voucher</button>
                    </div>

                    <div class="card-body">
                        <div class="live-preview">
                            <div class="row align-items-center g-12">
                                <div class="col-lg-12">
                                    <div class="table-responsive table-card">
                                        <div v-if='VoucherSeen'>
                                            <div class="spinner-bVoucher text-success" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            
                                            <DataTable class="table align-middle table-nowrap mb-0">
                                                <thead >
                                                    <tr>
                                                        <th scope="col">GENERAL VOUCHER NAME</th>
                                                        <!-- <th scope="col">VOUCHER CODE</th> -->
                                                        <th scope="col">STATUS</th>
                                                        <th scope="col">COUNTRY</th>
                                                        <th scope="col">IN/OUT</th>
                                                        <th scope="col">CREATED AT</th>
                                                        <th scope="col">UPDATED DATE</th>
                                                        <th scope="col">ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in VoucherList" :key="index" class="content">
                                                        <td>{{item.name}}</td>
                                                        <!-- <td>{{item.code}}</td> -->
                                                        <td>
                                                            <span v-if="item.status == 1" class="badge ms-auto bg-success">Active</span>
                                                            <span v-if="item.status == 0" class="badge ms-auto bg-danger">Inactive</span>
                                                        </td>
                                                        <td>
                                                            {{item.country_name}}
                                                        </td>
                                                        <td>
                                                            {{item.pid_tradeup}}/{{item.pid_tradein}}
                                                        </td>
                                                        <td>{{format_date(item.created_at)}}</td>
                                                        <td>{{format_date(item.updated_at)}}</td>
                                                        <td> 
                                                            <i data-bs-toggle="modal" href="#voucheradd" @click="editdata(item)" class="ri-pencil-fill align-bottom me-2 text-muted" style="cursor: pointer;"></i>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </DataTable>
                                            <br><br><br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="voucheradd" tabindex="-1" role="dialog" aria-labelledby="voucheraddLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="voucheraddLabel"></h5>
                                <button type="button" id="closemodal" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <form >
                                    <div class="row g-3">
                                        <div class="col-xxl-12">
                                            <div>
                                                <label for="selectStartDate" class="form-label">Voucher Effective Date<span class="text-danger">*</span></label>
                                                <flat-pickr type="number" v-model="startDate" placeholder="Voucher Start Date" :config="date" class="form-control"></flat-pickr>
                                                <span style="color: red;" v-if="error_startDate !=''">
                                                            {{ error_startDate }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-xxl-12">
                                            <div>
                                                <label for="selectEndDate" class="form-label">Voucher End Date<span class="text-danger">*</span></label>
                                                <flat-pickr type="number" v-model="endDate" placeholder="Select End Date" :config="date" class="form-control"></flat-pickr>
                                                <span style="color: red;" v-if="error_endDate !=''">
                                                            {{ error_endDate }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- <div class="col-xxl-12">
                                            <div>
                                                <label for="voucherEffectiveDate" class="form-label">Voucher Effective Date<span class="text-danger">*</span></label>
                                                <flat-pickr v-model="endDate" placeholder="Select Voucher Effective Date" :config="date" class="form-control"></flat-pickr>
                                            </div>
                                        </div> -->

                                        <div class="col-xxl-12">
                                            <label for="voucherCode" class="form-label">Country<span class="text-danger">*</span></label>
                                            <select v-model="country_" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                                <option value="">Please select country</option>
                                                <option v-for="(item, index) in country" :key="index" :value="item.id" >
                                                    {{ item.currency }} - {{ item.country }}
                                                </option>
                                            </select>
                                            <span style="color: red;" v-if="error_country !=''">
                                                            {{ error_country }}
                                            </span>
                                        </div>

                                        <div id="status" class="col-xxl-12">
                                            <label for="status" class="form-label">Status<span class="text-danger">*</span></label>
                                            <select v-model="status" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                                <option value="">Please select status</option>
                                                <option value= "1" >
                                                    Active
                                                </option>
                                                <option value= "0" >
                                                    Inactive
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xxl-12">
                                            <div>
                                                <label for="voucherCode" class="form-label">General Voucher Name <span class="text-danger">*</span></label>
                                                <input type="text" v-model='vouchername' class="form-control" id="voucherName" placeholder="Enter Voucher Name" required/>
                                                <span style="color: red;" v-if="error_vouchername !=''">
                                                            {{ error_vouchername }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-xxl-12">
                                            <label for="voucherCode" class="form-label">Upload File<span class="text-danger">*</span></label>
                                            <!-- <a :href="staticURLDownload+'storage/template/priceInfo_template.xlsx'"  class="btn btn-success btn-label" type="button"><i class="ri-folder-download-line label-icon align-middle fs-16 me-2"></i> Download Voucher Template</a> -->
                                            <input type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload">
                                            <br>
                                            <div v-if="filename !=''">
                                                <label for="voucherCode" class="form-label">File Uploaded :</label>
                                                <a v-bind:href="cloudFrontURL+'storage/voucher/'+filename" target="_blank" rel="noreferrer noopener">{{ this.filename }}</a>

                                            </div>
                                           
                                            <span style="color: red;" v-if="error_file !=''">
                                                            {{ error_file }}
                                            </span>

                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-success" id="add-btn" @click="AddNewVoucher">Add Voucher</button>
                                <button type="button" class="btn btn-success" id="edit-btn" @click="UpdateVoucher">Update</button>
                            </div>
                            </div>
                        </div>
                    </div>

            
                                            
                </div>
            </div>
        </div>
    </Layout>
</template>